module.exports = __webpack_public_path__ + "media/images/not_found-4ec1933af5f465bfa6d7b938c047b55f.png";